import styled from '@emotion/styled'
import { RelativeInfo } from '../../../../services/enrollment/enrollment-types'
import iconUser from '../../../../assets/images/icons-user-green-32-px.svg'
import iconEdit from '../../../../assets/images/icons-edit-18-px.svg'
import iconDelete from '../../../../assets/images/icons-delete-18-px.svg'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import { useCallback, useState } from 'react'
import { useHistory } from 'react-router'
import { editRelativeBenefits, insuranceFamilyForm } from '../../../../constant/path'
import {
  useDeleteRelative,
  useGetEnrollmentPeriod,
} from '../../../../services/enrollment/enrollment-query'
import { FONT_LIGHT_GRAY, PRIMARY } from '../../../../constant/colors'
import { useVisibility } from '../../../../utils/custom-hook'
import { Modal } from '../../../../components/common/Modal'
import { mobile } from '../../../../utils/responsive-helper'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { useRouter } from '../../../../utils/helper'

const Layout = styled.div`
  text-align: center;
  padding-right: 16%;
  padding-left: 16%;
  ${mobile} {
    padding-left: 0px;
    padding-right: 0px;
  }
`
const LayoutCard = styled.div`
  background-color: WHITE;
  border-radius: 8px;
  margin-top: 16px;
  border: solid 1px #dee2e6;
`

const ContentCard = styled.div`
  padding: 16px;
`

const ActionContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const Line = styled.div`
  border-top: solid 1px #dee2e6;
`

const IconStyle = styled.div`
  padding-right: 16px;
`

const getAge = (birthDate: number) => {
  const now = dayjs()
  var age = now.diff(dayjs(birthDate), 'year')
  return age
}

export type RelativeCardProps = {
  typeName: string
  relativeInfo: RelativeInfo[]
}

const RelativeCard = (props: RelativeCardProps) => {
  const { query } = useRouter()
  const { relativeInfo, typeName } = props
  const history = useHistory()
  const { data: enrollmentPeriod } = useGetEnrollmentPeriod()
  const { mutate: deleteRelative } = useDeleteRelative()
  const onRelativeForm = useCallback(
    (relativeId: number | undefined, relativeTypeId: number) => {
      history.push(
        insuranceFamilyForm({
          queryParam: {
            relativeTypeId: relativeTypeId,
            relativeId: relativeId,
            typeName: typeName,
          },
          routeParam: {
            benefitYearId: enrollmentPeriod?.benefitYearId!,
          },
        }),
      )
    },
    [enrollmentPeriod?.benefitYearId, history, typeName],
  )
  const [modalVisiblelity, modal] = useVisibility()
  const [relative, setRelative] = useState({ id: 0, name: '' })

  const onChooseBenefit = useCallback(
    (relativeId: number) => {
      history.push(
        editRelativeBenefits({
          routeParam: {
            benefitYearId: query.benefitYearId,
            relativeId: relativeId,
          },
        }),
      )
    },
    [history, query.benefitYearId],
  )

  const onEdit = useCallback(
    (relativeId: number, relativeTypeId: number) => {
      onRelativeForm(relativeId, relativeTypeId)
    },
    [onRelativeForm],
  )

  const onDelete = useCallback(
    (relativeId: number) => {
      deleteRelative(relativeId)
    },
    [deleteRelative],
  )

  return (
    <Layout>
      <Modal
        visible={modalVisiblelity}
        onOk={() => {
          onDelete(relative.id)
          modal.hide()
        }}
        onCancel={modal.hide}
      >
        <Text style={{ marginTop: '24px' }}>คุณต้องการที่จะลบ {relative.name} ใช่หรือไม่?</Text>
      </Modal>
      {relativeInfo.map((v) => (
        <LayoutCard key={`${v.id}-${v.userId}`}>
          <ContentCard>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <IconStyle>
                <Image src={iconUser} width={32} height={32} />
              </IconStyle>
              <div style={{ flexWrap: 'wrap', display: 'flex', flexDirection: 'row' }}>
                <Text size={22} type="Bold">
                  {v.title}
                </Text>
                <Text size={22} type="Bold">
                  {v.firstname}{' '}
                </Text>
                <Text size={22} type="Bold" style={{ marginLeft: '4px' }}>
                  {v.lastname}
                </Text>
                <Text size={22} type="Bold" color={FONT_LIGHT_GRAY} style={{ marginLeft: '4px' }}>
                  ({getAge(v.birthday)} ปี)
                </Text>
              </div>
            </div>
            {/* <Text
              style={{ textAlign: 'start', paddingTop: '8px' }}
              size={18}
              type="Medium"
              color={FONT_LIGHT_GRAY}
            >
              บัตรประชาชน : {v.nationalId}{' '}
            </Text> */}
          </ContentCard>
          <Line />
          <ContentCard>
            <ActionContent>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => onChooseBenefit(v.id)}
              >
                <Text size={28} type="Medium" color={PRIMARY}>
                  +
                </Text>
                <Text size={15} type="Medium" color={PRIMARY}>
                  เลือกประกัน
                </Text>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {' '}
                <div
                  style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                  onClick={() => onEdit(v.id, v.relativeTypeId)}
                >
                  <Image src={iconEdit} width={18} height={18} style={{ paddingRight: '4px' }} />
                  <Text size={15} type="Medium" color={'#ffb045'}>
                    แก้ไข
                  </Text>
                </div>
                <div style={{ width: '16px' }} />
                <div
                  style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                  onClick={() => {
                    setRelative({ id: v.id, name: `${v.firstname} ${v.lastname}` })
                    modal.show()
                  }}
                >
                  <Image src={iconDelete} width={18} height={18} style={{ paddingRight: '4px' }} />
                  <Text size={15} type="Medium" color={'#f90000'}>
                    ลบ
                  </Text>
                </div>
              </div>
            </ActionContent>
          </ContentCard>
        </LayoutCard>
      ))}
    </Layout>
  )
}

export default RelativeCard
